import React from 'react';
import {
  Home,
  ShoppingCart,
  Target,
  Gift,
  User,
  Sun,
  Moon,
  Eye,
  EyeOff,
  ArrowLeft,
  ArrowRight,
  Send,
  Mic,
  Square,
  Camera,
  Image,
  Clock,
  Check,
  X,
  Menu,
  LogOut,
  Settings,
  Bell,
  Search,
  Plus,
  Minus,
  ChevronDown,
  ChevronUp,
  TrendingUp,
  ChevronLeft,
  ChevronRight,
  MoreHorizontal,
  Heart,
  Star,
  MessageCircle,
  Phone,
  Mail,
  MapPin,
  Calendar,
  Filter,
  Download,
  Upload,
  Edit,
  Trash2,
  Copy,
  Share,
  ExternalLink,
  Lock,
  Unlock,
  AlertCircle,
  CheckCircle,
  Info,
  XCircle,
  Loader2,
  Truck,
  HelpCircle,
  Package,
  DollarSign,
  List,
  MessageSquare,
  Play,
  type LucideIcon,
} from 'lucide-react';

interface IconProps {
  name: string;
  size?: number;
  className?: string;
  color?: string;
}

const iconMap: Record<string, LucideIcon> = {
  // Navigation
  home: Home,
  'shopping-cart': ShoppingCart,
  target: Target,
  gift: Gift,
  user: User,
  
  // UI Controls
  sun: Sun,
  moon: Moon,
  eye: Eye,
  'eye-off': EyeOff,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  send: Send,
  mic: Mic,
  microphone: Mic,
  square: Square,
  camera: Camera,
  image: Image,
  photo: Image,
  clock: Clock,
  check: Check,
  close: X,
  menu: Menu,
  logout: LogOut,
  settings: Settings,
  
  // Actions
  bell: Bell,
  search: Search,
  plus: Plus,
  minus: Minus,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'trending-up': TrendingUp,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'more-horizontal': MoreHorizontal,
  
  // Social
  heart: Heart,
  star: Star,
  'message-circle': MessageCircle,
  
  // Contact
  phone: Phone,
  mail: Mail,
  'map-pin': MapPin,
  calendar: Calendar,
  
  // Tools
  filter: Filter,
  download: Download,
  upload: Upload,
  edit: Edit,
  'trash-2': Trash2,
  copy: Copy,
  share: Share,
  'external-link': ExternalLink,
  
  // Security
  lock: Lock,
  unlock: Unlock,
  
  // Status
  'alert-circle': AlertCircle,
  'check-circle': CheckCircle,
  info: Info,
  'x-circle': XCircle,
  'loader-2': Loader2,
  
  // Additional
  truck: Truck,
  'help-circle': HelpCircle,
  package: Package,
  x: X,
  
  // Order Details Modal
  'dollar-sign': DollarSign,
  list: List,
  'message-square': MessageSquare,
  
  // Mission Actions
  play: Play,
};

const Icon: React.FC<IconProps> = ({ name, size = 20, className = '', color }) => {
  const IconComponent = iconMap[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <IconComponent 
      size={size} 
      className={className}
      color={color}
    />
  );
};

export default Icon;
